export default __webpack_public_path__ + "static/assets/27642fd112278fba0354642a67a2c285.png";